export default __webpack_public_path__ + "static/from-abroad-m-banner-8929f334889ff09f2fef7a4666885760.jpg";